import { FC } from 'react';
import Link from '@base/lib/Link';
import { IHelpGroup } from 'mod/help/interface';
import { useTrans } from 'base/utils/i18n';
import { LoopRender } from '@base/snippets/LoopRender';

type ITiledHelpGroupsProps = {
    groups: IHelpGroup[];
    className?: string;
    onLinkClick?: () => void;
};

export const TiledHelpGroups: FC<ITiledHelpGroupsProps> = ({ groups, className, onLinkClick }) => {
    const { t } = useTrans();
    return (
        <LoopRender
            className={className}
            list={groups}
            render={group => (
                <div className={`g-group g-group-${group.key.toLowerCase().replace(/\s/g, '-')}`} key={group.key}>
                    <p className="g-group-title">
                        <Link href={group.link} onClick={onLinkClick}>
                            <strong>{t(group.title)}</strong>
                        </Link>
                    </p>

                    {!!group.list?.length && (
                        <ul className="g-group-body">
                            {group.list.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <Link
                                            href={item.link}
                                            onClick={onLinkClick}
                                            {...(item.linkProps || {})}
                                        >
                                            {t(item.title)}
                                        </Link>
                                    </li>
                                )
                            })}
                        </ul>
                    )}

                </div>
            )}
        />
    );
};
